import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {ApiClientService} from '../../../services/api-client.service';
import {ParcelsService} from '../../../services/parcels.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {AuthenticationService} from '../../../services/authentication.service';

declare const toastr: any;
declare const $: any;
declare const swal: any;

@Component({
    selector: 'parcel-reminder-modal',
    templateUrl: './parcel-reminder-modal.component.html',
    styleUrls: ['./parcel-reminder-modal.component.scss']
})
export class ParcelReminderModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    data: any;
    disabledSubmit = false;
    message = '';
    showSpinner = false;

    constructor(
        public api: ApiClientService,
        public parcelsService: ParcelsService,
        public urlService: UrlService,
        public authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.initData();
        setTimeout( () => this.showModal = true, 300);
        setTimeout( () => this.initSummernote(), 300);
        this.urlService.modalOpened.emit();
    }

    initData() {
        this.data = {
            id: this.parcelsService.parcelInParcelModal.residentId,
            name: this.parcelsService.parcelInParcelModal.residentFullName,
            email: this.parcelsService.parcelInParcelModal.residentEmail,
            phone: this.parcelsService.parcelInParcelModal.residentPhone,
            parcelNumber: this.parcelsService.parcelInParcelModal.parcelNumber,
            buildingName: this.parcelsService.parcelInParcelModal.buildingName,
        };
        this.message = `${this.data.name},<br/><br/>
                        Did you forget? Your parcel # ${this.data.parcelNumber} is really sad. It's sitting here in a cold dark room and no one came to pick it up!<br/><br/>
                        It is located at the front desk of ${this.data.buildingName}, so please come quickly.<br/><br/>
                        Please grab your photo ID just in case… We don’t want to give it to the wrong person!<br/><br/>
                        We look forward to see you at the front desk.`;
    }

    hideModal() {
        if (this.form.dirty && this.form.touched) {
            swal(ConstantsService.getSwalConfig('Close without saving?', 'Do you want to delete unsaved data?'),
                () => {
                    this.parcelsService.isParcelReminderModalShow = false;
                    this.parcelsService.parcelInParcelModal = null;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.parcelsService.isParcelReminderModalShow = false;
            this.parcelsService.parcelInParcelModal = null;
            this.urlService.modalClosed.emit();
        }
    }

    initSummernote() {
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            toolbar: [],
            disableDragAndDrop: true
        });
        $('.note-editable').html(this.message).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        $('#summernote').summernote('disable');
    }

    onSubmit(form: NgForm): void {
        this.disabledSubmit = true;
        this.showSpinner = true;

        const recipients = [{
            name: this.data.name,
            email: this.data.email,
            type: 'resident',
            // type: resident.role,
            buildingId: this.parcelsService.parcelInParcelModal.buildingId,
            buildingName: this.parcelsService.parcelInParcelModal.buildingName,
            // buildingAddress: this.parcelsService.parcelInParcelModal.buildingAddress,
            suiteId: this.parcelsService.parcelInParcelModal.suiteId,
            suiteName: this.parcelsService.parcelInParcelModal.suiteNumber,
            bdId: this.data.id,
            // homePhone: resident.phones.find(p => p.phoneType == 'phone_home') ? resident.phones.find(p => p.phoneType == 'phone_home').phone : undefined,
            // mobilePhone: resident.phones.find(p => p.phoneType == 'phone_cell') ? resident.phones.find(p => p.phoneType == 'phone_cell').phone : undefined,
            // businessPhone: resident.phones.find(p => p.phoneType == 'phone_business') ? resident.phones.find(p => p.phoneType == 'phone_business').phone : undefined
        }];

        const filters = [{
            buildingId: this.parcelsService.parcelInParcelModal.buildingId,
            buildingName: this.parcelsService.parcelInParcelModal.buildingName,
            checkedResidents: [this.parcelsService.parcelInParcelModal.suiteId],
            groups: [],
            guestChecked: 0,
            guestCount: 0,
            guestHalfChecked: 0,
            notSetChecked: 0,
            notSetCount: 0,
            notSetHalfChecked: 0,
            occupantChecked: 0,
            occupantCount: 0,
            occupantHalfChecked: 0,
            offsiteResidentChecked: 0,
            offsiteResidentCount: 0,
            offsiteResidentHalfChecked: 0,
            ownerFamilyChecked: 0,
            ownerFamilyCount: 0,
            ownerFamilyHalfChecked: 0,
            ownerOffChecked: 0,
            ownerOffCount: 0,
            ownerOffHalfChecked: 0,
            ownerOnChecked: 0,
            ownerOnCount: 0,
            ownerOnHalfChecked: 0,
            residentChecked: 1,
            residentCount: 1,
            residentHalfChecked: 1,
            residentOnlyNotOnDeedChecked: 0,
            residentOnlyNotOnDeedCount: 0,
            residentOnlyNotOnDeedHalfChecked: 0,
            residentOwnerChecked: 0,
            residentOwnerCount: 0,
            residentOwnerHalfChecked: 0,
            tenantsChecked: 0,
            tenantsCount: 0,
            tenantsHalfChecked: 0
        }];

        const data: any = {
            sender: 'notice@maxcondoclub.ca',
            subject: `${this.data.parcelNumber} Parcel Reminder`,
            message: this.message,
            sendMeCopy: 0,
            filters: JSON.stringify(filters),
            recipients: recipients,
            attachments: [],
            pmEmail: this.authenticationService.user.email,
            pmMobilePhone: this.authenticationService.user.primaryPhone,
            pmName: this.authenticationService.user.fullName,
            buildingId: [this.parcelsService.parcelInParcelModal.buildingId],
            buildingName: this.parcelsService.parcelInParcelModal.buildingName,
            // buildingAddress: this.parcelsService.parcelInParcelModal.buildingAddress,
            status: 'in_progress',
        };
        this.api.post('domainEmails', '/api/v1/mailings', data).subscribe(
            response => {
                toastr.success('Reminder has been sent successfully.');
                this.parcelsService.parcelInParcelModal.reminderSentAt = new Date().toISOString();
                this.hideModal();
            },
            error => {
                this.api.errorHandler(error, 'Failed to send reminder');
                this.disabledSubmit = false;
                this.showSpinner = false;
            }
        );
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parcels/parcel-reminder-modal/parcel-reminder-modal.component.ts